import Application from './application';

export default class Testimony extends Application {
  attrs = {
    createdAt: { serialize: false },
    image: { serialize: false },
  };
}

// DO NOT DELETE: this is how TypeScript knows how to look up your serializers.
declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    testimony: Testimony;
  }
}
